import React from 'react';
import { Box } from '@mui/material';
import SquareIcon from '@mui/icons-material/Square'; // Using a solid square icon
import { getProficiencyValue } from '../ProficiencyUtils';

const SquaresProficiency = ({ proficiency, classes, colors }) => {
  const level = getProficiencyValue(proficiency);
  if (level === 0) return null;

  const maxLevel = 5;
  const primaryColor = colors?.primary || '#000';
  const secondaryColor = colors?.textSecondary || '#aaa';

  return (
    <Box
      className={classes?.proficiencyVisualization || ''}
      sx={{ display: 'inline-flex', alignItems: 'center', gap: '3px', marginLeft: '8px' }}
    >
      {Array.from({ length: maxLevel }).map((_, i) => (
        <SquareIcon
          key={i}
          className={i < level ? (classes?.proficiencyFilled || '') : (classes?.proficiencyEmpty || '')}
          sx={{
            color: i < level ? primaryColor : secondaryColor,
            fontSize: '10px', // Adjust size as needed
          }}
        />
      ))}
    </Box>
  );
};

export default SquaresProficiency; 